<script setup lang="ts">
import SovendusWidget from "~/components/static/SovendusWidget.vue";
import { sovendusAvailable } from "~/utils/service";

const {locale} = await useLocale("typ", "typ_metlife_ko", true);
const emit = defineEmits(["init"]);

defineComponent({
  name: "TypClubKO",
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  showSovendus: {
    type: Boolean,
    default: true
  }
});
onMounted(() => emit("init"));
</script>

<template>
  <div class="w-11/12 sm:max-w-7xl mx-auto shadow-lg rounded-3xl bg-white mt-4 mb-10 lg:my-10" >
    <div class="px-4 mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700" >
      <h3 class="p-2 pt-8 text-center text-2xl sm:text-3xl font-semibold" v-html="locale?.header.replace('%d', name)" />
      <h4
        class="text-center text-lg sm:text-xl mb-4  font-semibold px-6"
        v-html="locale?.subheader"
      />
      <div class="max-w-4xl text-lg mx-auto p-4">
        <p class=" text-center mt-4 mb-8" v-html="locale?.title.replace('%t', type)"/>
        <p class="text-center mt-12" v-html="locale?.thanks" />
      </div>
    </div>
    <div class="spacer h-6" />
    <SovendusWidget v-if="sovendusAvailable() && showSovendus" />
  </div>

</template>

<style scoped></style>
